<template>
    <v-container class="table" pt-0 pl-0>
        <div v-if="value.canEdit">
            <v-layout>
                <table>
                    <thead>
                    <tr>
                        <th>Название компании</th>
                        <th>Кросс-продукт (проценты)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="company in value.companies" :key="company.alias" v-show="company.show">
                        <td class="table-data">
                            <v-flex>
                                <v-img
                                    class="logo"
                                    :src="company.logo"
                                    :alt="company.name"
                                >
                                </v-img>
                                <span>{{ company.name }}</span>
                            </v-flex>
                        </td>
                        <td class="table-data">
                            <ul>
                                <li v-for="cross in company.crosses" :key="cross.id">
                                    <v-layout align-center>
                                        <v-flex xs8>
                                            {{ cross.cross_title }} ({{ cross.premium }})
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                :rules="[rules.commission]"
                                                validate-on-blur
                                                v-model.lazy="value.commissions[company.alias][cross.id]"
                                                suffix="%"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </v-layout>
        </div>

        <div v-if="!value.canEdit">
            <v-layout>
                <table>
                    <thead>
                    <tr>
                        <th>Название компании</th>
                        <th>Кросс-продукт</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="company in value.companies" :key="company.alias" v-show="company.show">
                        <td class="table-data">
                            <v-flex>
                                <v-img
                                    class="logo"
                                    :src="company.logo"
                                    :alt="company.name"
                                >
                                </v-img>
                                <span>{{ company.name }}</span>
                            </v-flex>
                        </td>
                        <td class="table-data">
                            <ul>
                                <li v-for="cross in company.crosses" :key="cross.id">
                                    <v-layout align-center>
                                        <v-flex xs8>
                                            {{ cross.cross_title }} ({{ cross.premium }})
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field
                                                disabled
                                                :rules="[rules.commission]"
                                                validate-on-blur
                                                v-model.lazy="value.commissions[company.alias][cross.id]"
                                                suffix="%"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </v-layout>
        </div>
    </v-container>
</template>

<script>

export default {
    props: {
        regionSearch: {
            default: ''
        },
        canEdit: {
            default: false
        },
        regions: {
            default: []

        },
        companies: {
            default: []
        },
        commissions: {
            default: []
        },
        commissionRules: {
            default: []
        }
    },
    data: () => ({
        searching: false,
        value: {
            canEdit: false,
            regions: [],
            companies: [],
            commissions: [],
            commissionRules: [],
        },
        rules: {
            commission: v => ((/^[0-9]+/.test(v) && v <= 100) || v ==='') || 'Ошибка',
        }
    }),
    created() {
        this.value.canEdit = this.canEdit;
        this.value.companies = this.companies.map(item => {
            let clone = Object.assign({}, item);
            clone.show = true;
            return clone;
        });
        this.value.commissions = this.commissions;
        this.value.commissionRules = this.commissionRules;
    },
    watch: {
        regionSearch() {
            if (this.searching) {
                return;
            }
            this.searching = true;
            this.value.companies.forEach(company => {
                company.show = !this.regionSearch || company.name.toLowerCase().indexOf(this.regionSearch.toLowerCase()) !== -1;
            });
            this.searching = false;
        }
    }
}
</script>

<style scoped>
.small-field {
    height: 100px;
    width: 110px;
    padding: 0 10px;
}

.region-field {
    width: 240px;
    padding-left: 0 !important;
    flex: initial;
}

.cant-edit-field {
    line-height: 100px;
    text-align: center;
}

.regions {
    border-bottom: solid 1px #eeeeee;
}

.cant-edit-region {
    min-height: 100px;
}

.table {
    margin: 20px;
    max-width: 1800px;
    max-height: 50%;
}

ul {
    list-style-type: none;
}

.logo {
    max-width: 118px;
    vertical-align: middle;
}

.table-data {
    border-bottom: 1px #eee solid;
}

.table-data span {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/CommissionsCrosses.vue